var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStep8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 44,
    viewBox: "0 0 54 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 33.5076L12.401 24L23.1248 34.2734L31.2484 27.437L40 35.5068V41H3V33.5076Z",
    fill: "url(#paint0_linear_2087:8098)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 18C26.6567 18 28 19.3433 28 21C28 22.6567 26.6567 24 25 24C23.3433 24 22 22.6567 22 21C22 19.3433 23.3433 18 25 18Z",
    fill: "url(#paint1_linear_2087:8098)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6846 7.81886L12.2674 0.683122C12.3697 0.216185 12.8396 -0.0809572 13.3149 0.019534L53.3047 8.57687C53.78 8.67737 54.0824 9.1391 53.9801 9.60604L47.5625 38.5553C47.4602 39.0222 46.9902 39.3194 46.5149 39.2189L45.4418 38.9893L45.3298 40.5911C45.3034 40.9939 44.9471 41.2989 44.5371 41.2729L42.6915 41.1481V43.1337C42.6915 43.6119 42.2965 44 41.8097 44H0.881783C0.395039 44 0 43.6119 0 43.1337V13.5061C0 13.0279 0.395039 12.6398 0.881783 12.6398H4.76957L5.08172 8.17578C5.10817 7.77294 5.46441 7.46801 5.87444 7.494L10.6846 7.81886ZM42.6915 39.6806L43.8943 39.762L45.8624 11.6644L6.51726 9.00483L6.26331 12.6398H41.8097C42.2965 12.6398 42.6915 13.0279 42.6915 13.5061V39.6797V39.6806ZM40.928 14.3733H1.76357V42.2683H40.928V14.3733ZM45.5644 37.2437L46.0273 37.3425L52.0702 10.0851L13.8026 1.89595L12.4622 7.93928L46.7063 10.254C47.1163 10.28 47.4267 10.63 47.4003 11.0328L45.5644 37.2428V37.2437Z",
    fill: "url(#paint2_linear_2087:8098)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2087:8098",
    x1: 3,
    y1: 24,
    x2: 15.8987,
    y2: 52.0736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2087:8098",
    x1: 22,
    y1: 18,
    x2: 28,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2087:8098",
    x1: 0,
    y1: 0,
    x2: 43.0932,
    y2: 52.8871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep8);
export default __webpack_public_path__ + "static/media/icon-step8.4eb1e8b5e77a67496c5a6b115ecbaa7b.svg";
export { ForwardRef as ReactComponent };